// Dev-only logging; silent in production builds.
const isDev = process.env.NODE_ENV === "development";

export const logger = {
  error: (...args) => { if (isDev) console.error(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
};
